import { MaskedLines, Reveal } from "./shared";
import { LightArt } from "./LightArt";

export const Finale = () => (
    <footer data-testid="finale-section" className="relative bg-black">
        <div className="relative flex min-h-[100svh] flex-col items-center justify-center overflow-hidden px-6 text-center">
            <LightArt variant="rings" hue="warm" className="absolute inset-0 opacity-40" />
            <div className="relative">
                <h2 className="font-display text-[11vw] font-bold uppercase leading-[0.95] tracking-tighter text-[#F4F2EF] sm:text-7xl lg:text-8xl">
                    <MaskedLines lines={["Make your", "space move."]} lineClassName="text-glow-warm" />
                </h2>
                <Reveal delay={0.6}>
                    <p className="mt-14 font-display text-lg font-bold tracking-[0.35em] text-white md:text-xl">MOTION TECH ARTS</p>
                    <p className="mt-4 font-mono-tech text-[10px] tracking-[0.4em] text-white/40">SPACES THAT MOVE. LIGHT THAT LIVES.</p>
                </Reveal>
            </div>
        </div>
        <Reveal y={0} className="relative border-t border-white/5">
            <div className="mx-auto flex max-w-[1600px] flex-col items-start justify-between gap-6 px-6 py-10 md:flex-row md:items-center md:px-12">
                <span className="font-mono-tech text-[10px] tracking-[0.3em] text-white/35">
                    © {new Date().getFullYear()} MOTION TECH ARTS
                </span>
                <a
                    data-testid="footer-email"
                    href="mailto:indialightingstudio@gmail.com"
                    className="font-mono-tech text-[10px] tracking-[0.3em] text-white/35 transition-colors duration-500 hover:text-white/80"
                >
                    INDIALIGHTINGSTUDIO@GMAIL.COM
                </a>
                <span className="font-mono-tech text-[10px] tracking-[0.3em] text-white/35">
                    WE DON'T SELL INSTALLATIONS. WE CREATE MOMENTS PEOPLE REMEMBER.
                </span>
            </div>
        </Reveal>
    </footer>
);
